export class CardDetail {

  private static numKeys = ['userCardID', 'userID', 'cvc'];
  private static stringKeys = ['stripeToken', 'stripeCardID', 'cardType', 'maskedCCNum', 'fullName', 'expDate'];
  private static booleanKeys = ['isCardExpired', 'isDefault', 'isActive'];

  userCardID: number;
  userID: number;
  stripeToken: string;
  stripeCardID: string;
  cardType: string;
  maskedCCNum: string;
  fullName: string;
  expDate: string;
  isCardExpired: boolean;
  cvc: number;
  isDefault: boolean;
  isActive: boolean;
  lastFour: string;

  constructor(data: any = {}) {
    CardDetail.numKeys.forEach(k => this[k] = +data[k]);
    CardDetail.stringKeys.forEach(k => this[k] = data[k]);
    CardDetail.booleanKeys.forEach(k => this[k] = !!data[k]);
    if (this.maskedCCNum) {
      this.lastFour = this.maskedCCNum.slice(this.maskedCCNum.length - 4, this.maskedCCNum.length);
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/models/user/card-detail.ts